module.exports = __webpack_public_path__ + "static/img/6.23157e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/objectRecognition/unity/6.png
// module id = CH1X
// module chunks = 1